import { render, staticRenderFns } from "./ReMatchDialogV2.vue?vue&type=template&id=07f86b51"
import script from "./ReMatchDialogV2.vue?vue&type=script&lang=js"
export * from "./ReMatchDialogV2.vue?vue&type=script&lang=js"
import style0 from "./ReMatchDialogV2.vue?vue&type=style&index=0&id=07f86b51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports